module.exports = __webpack_public_path__ + "img/playIcon.56265db0.png";